import React from 'react'

import LabelDetail from '../../UI/Label/LabelDetail'


const Agency = props => {
    const agency = props.agency

    return (
        <div className="columns">
            <div className="column">
                <table className='table is-bordered is-fullwidth table-info'>
                    <tbody>
                        <tr>
                            <td>
                                <LabelDetail
                                    title='inegi'
                                    description={agency.inegi_code}
                                />
                            </td>
                            <td>
                                <LabelDetail
                                    title='Entidad'
                                    description={agency.state}
                                />
                            </td>
                            <td>
                                <LabelDetail
                                    title='municipio'
                                    description={agency.municipality}
                                />
                            </td>
                            <td>
                                <LabelDetail
                                    title='tipo'
                                    description={agency.type}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="4">
                                <LabelDetail
                                    title='nombre'
                                    description={agency.name}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <LabelDetail
                                    title='colonia'
                                    description={agency.suburb}
                                />
                            </td>
                            <td>
                                <LabelDetail
                                    title='calle'
                                    description={agency.street}
                                />
                            </td>
                            <td>
                                <div className="two-inline">
                                    <LabelDetail
                                        title='núm. ext.'
                                        description={agency.num_ext}
                                    />
                                    <LabelDetail
                                        title='int'
                                        description={agency.num_int}
                                    />
                                </div>
                            </td>
                            <td>
                                <LabelDetail
                                    title='c.p.'
                                    description={agency.zip_code}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2">
                                <LabelDetail
                                    title='correo electrónico'
                                    description={agency.email}
                                />
                            </td>
                            <td colSpan="2">
                                <LabelDetail
                                    title='correo electrónico 2'
                                    description={agency.email_2}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2">
                                <LabelDetail
                                    title='teléfono'
                                    description={agency.phone}
                                />
                            </td>
                            <td colSpan="2">
                                <LabelDetail
                                    title='teléfono 2'
                                    description={agency.phone_2}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Agency


// WEBPACK FOOTER //
// ./src/acervo/components/Sections/Detail/Agency.js